import React, { useEffect, useMemo, useState } from "react";
import {
  Box,
  Typography,
  Paper,
  Button,
  Divider,
} from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import CheckoutBreadcrumbs from "./CheckoutBreadcrumbs";
import { getCheckout, setCheckout } from "../utils/buyNowStorage";
import api from "../api/axios";

const OrderSummary = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const checkout = useMemo(() => getCheckout(), []);
  const addressId = location.state?.addressId;
  const [address, setAddress] = useState(null);

  useEffect(() => {
    if (!checkout?.items?.length) {
      navigate("/", { replace: true });
      return;
    }

    if (!addressId) {
      navigate("/delivery-location", { replace: true });
      return;
    }

    const user = JSON.parse(localStorage.getItem("user"));
    if (!user?.username) {
      navigate("/login");
      return;
    }

    let isMounted = true;

    api
      .get(`/users/${user.username}/addresses/${addressId}`)
      .then((res) => {
        if (!isMounted) return;
        setAddress(res.data.address);
        if (checkout.addressId !== addressId) {
          setCheckout({ ...checkout, addressId });
        }
      })
      .catch(() => {
        if (!isMounted) return;
        navigate("/delivery-location", { replace: true });
      });

    return () => {
      isMounted = false;
    };
  }, [addressId, checkout, navigate]);

  if (!checkout || !address) return null;

  const checkoutItems = checkout.items ?? [];
  const subtotal = checkoutItems.reduce((sum, item) => sum + item.price * item.qty, 0);
  const shipping = subtotal > 500 ? 0 : 49;
  const total = subtotal + shipping;
  const formatCurrency = (value) => `₹${Number(value).toLocaleString("en-IN")}`;

  return (
    <Box sx={{ maxWidth: 600, mx: "auto",  p: 2 }}>
      <CheckoutBreadcrumbs active={1} />

      <Paper sx={{ p: 3 }}>
        <Typography variant="h6" fontWeight={700}>
          Order Summary
        </Typography>

        {checkoutItems.map((item, i) => (
          <Box key={item.id ?? `${item.title}-${i}`} sx={{ my: 2 }}>
            <Typography fontWeight={600}>{item.title}</Typography>
            <Typography>Qty: {item.qty}</Typography>
            <Typography>{formatCurrency(item.price * item.qty)}</Typography>
          </Box>
        ))}

        <Divider sx={{ my: 2 }} />
        <Typography>Subtotal: {formatCurrency(subtotal)}</Typography>
        <Typography>Shipping: {formatCurrency(shipping)}</Typography>
        <Typography fontWeight={700}>Total: {formatCurrency(total)}</Typography>

        <Divider sx={{ my: 2 }} />

        <Typography fontWeight={600}>Deliver to:</Typography>
        <Typography>
          {address.addressLine1}, {address.city} - {address.pincode}
        </Typography>

        <Button
          fullWidth
          sx={{ mt: 3 }}
          variant="contained"
          onClick={() => navigate("/payment")}
        >
          Proceed to Payment
        </Button>
      </Paper>
    </Box>
  );
};

export default OrderSummary;
